// Password strength meter — purely advisory (not a requirement). Returns
// {level: 0..3, label, color, advice}. Levels:
//   0 Very Weak, 1 Weak, 2 Strong, 3 Very Strong
// Heuristic considers length + character variety (lower, upper, digit, symbol).
export function scorePassword(pw) {
  if (!pw) return { level: -1, label: "", color: "#2A2A2A", pct: 0, advice: "" };
  const len = pw.length;
  const hasLower = /[a-z]/.test(pw);
  const hasUpper = /[A-Z]/.test(pw);
  const hasDigit = /[0-9]/.test(pw);
  const hasSymbol = /[^A-Za-z0-9]/.test(pw);
  const variety = hasLower + hasUpper + hasDigit + hasSymbol;

  let level;
  if (len < 6) level = 0;
  else if (len < 8 || variety <= 1) level = 1;
  else if (len >= 12 && variety >= 3) level = 3;
  else if (len >= 8 && variety >= 2) level = 2;
  else level = 1;

  const meta = [
    { label: "Very Weak", color: "#FF3B30", pct: 25, advice: "Add more characters or mix upper/lower/symbols." },
    { label: "Weak", color: "#FFCC00", pct: 50, advice: "Try 10+ characters or add a symbol." },
    { label: "Strong", color: "#00C781", pct: 80, advice: "Looks good." },
    { label: "Very Strong", color: "#0055FF", pct: 100, advice: "Excellent." },
  ][level];
  return { level, ...meta };
}

export default function PasswordStrength({ password }) {
  const s = scorePassword(password);
  if (s.level < 0) {
    return (
      <p className="mt-1.5 text-[10px] text-[#555]" data-testid="password-strength">
        Suggested: 8+ characters, mix letters, numbers & symbols
      </p>
    );
  }
  return (
    <div className="mt-1.5" data-testid="password-strength">
      <div className="h-1 rounded-full bg-[#1a1a1a] overflow-hidden">
        <div
          className="h-full transition-all"
          style={{ width: `${s.pct}%`, background: s.color }}
          data-testid="password-strength-bar"
        />
      </div>
      <div className="mt-1 flex items-center justify-between text-[10px]">
        <span style={{ color: s.color }} data-testid="password-strength-label">{s.label}</span>
        <span className="text-[#555]">{s.advice}</span>
      </div>
    </div>
  );
}
